/**
 * Triggers a browser download of JSON data as a file.
 * Creates a temporary Blob URL, clicks an anchor element, then cleans up.
 */
export const downloadJsonFile = (data: unknown, fileName: string): void => {
  const json = JSON.stringify(data, null, 2)
  const blob = new Blob([json], { type: 'application/json' })
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = fileName
  document.body.appendChild(anchor)
  anchor.click()
  document.body.removeChild(anchor)
  setTimeout(() => URL.revokeObjectURL(url), 100)
}
